import format from 'date-fns/format';
import formatRelative from 'date-fns/formatRelative';
import isWithinInterval from 'date-fns/isWithinInterval';
import subDays from 'date-fns/subDays';
import addDays from 'date-fns/addDays';
import locale from 'date-fns/locale/pt-BR';
import uppercaseFirstLetter from './uppercase-first-letter.js';

/*
  Date-fns uses unicode tokens to format the data
  @see: https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
*/
const defaultDateFormat = "dd/MM/yyyy 'às' H':'mm";

var humanizeDate = (date, { dateFormat = defaultDateFormat, relative = true } = {}) => {
  const givenDate = new Date(date);
  const today = new Date();

  const shouldBeRelativeFormatted =
    relative &&
    isWithinInterval(givenDate, {
      start: subDays(today, 1),
      end: addDays(today, 1),
    });

  return shouldBeRelativeFormatted
    ? uppercaseFirstLetter(formatRelative(givenDate, today, { locale }))
    : format(givenDate, dateFormat, { locale });
};

export { humanizeDate as default };
//# sourceMappingURL=humanize-date.js.map
